import { InMemoryCache } from '@apollo/client/core';

export const inMemoryCache = new InMemoryCache({
  possibleTypes: {
    ReportPluginParams: ['LineChartParams', 'DemandParams', 'HeatMapParams', 'TextEditorParams', 'ShiftrParams', 'ClusterParams'],
    ReportPluginData: ['LineChartData', 'DemandData', 'HeatMapData', 'TextEditorData', 'TextEditorData', 'ShiftrData', 'ClusterData']
  }
});
